module.exports = __webpack_public_path__ + "static/media/bl.db226c04.png";